import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import { Content } from '@/components/Rankings/style.css'
import { Columns } from '@/components/Article/style.css'
import Summary from '@/components/Summary'
import data from '@/components/Feature/Rankings/Data'
import TitleSelector from '@/components/Feature/Rankings/TitleSelector'
import { CalidadDelMercadoLaboral } from '@/components/Feature/Rankings/Output'

const IndexPage = () => {
  const rankings = data.filter(item => item.name === 'Rankings')[0].rankings
  const datalocal = rankings.find(
    item => item.link === '/rankings-generales/percepcion-de-calidad/',
  )

  return (
    <Layout>
      <SEO
        title={datalocal.name}
        keywords={[
          `La Tercera`,
          `${datalocal.name}`,
          `Ranking de Universidades Chilenas 2021`,
        ]}
      />
      <Content>
        <TitleSelector
          pretitle="Ranking de Universidades 2021"
          allRankings={rankings}
          section="rankings-generales"
          sectionSlug={datalocal.slug}
        />
        <Columns>
          <p>
            Le pedimos a los ejecutivos que deciden directa o indirectamente la
            contratación de futuros profesionales en el país que evaluaran a las
            universidades que conforman el sistema. ¿La razón? Elaborar un
            estudio que mide la percepción de calidad y el nivel de conocimiento
            que los empleadores otorgan a estos planteles. Este año fueron 2.700
            los profesionales que participaron y sus opiniones fueron recogidas,
            en noviembre pasado, por la empresa de estudio e investigación de
            mercados Feedback.{' '}
          </p>

          <p>
            A excepción de las universidades de O'Higgins y de Aysén, que
            comenzaron sus operaciones en 2015, los encuestados les pusieron
            nota a todos los planteles, sin embargo se publican los resultados
            de las universidades que son medidas en este ranking, es decir las
            43 casas de estudio que están acreditadas y que han publicado al
            menos 50 papers en una ventana de cinco años —2015-2019—.{' '}
          </p>

          <p>
            En esta versión, por primera vez en 22 años, el Top 11 se mantiene
            sin movimiento. Eso sí, solo 19 universidades mantienen la misma
            posición que en 2020. Once, en cambio, subieron nota. Las mayores
            alzas son las de la U. de Atacama, que del puesto 34 subió al 29 y
            la U. San Sebastián, que avanzó cuatro puestos, instalándose en el
            27. Las que descienden notoriamente son la U. de Playa Ancha, que
            bajó al lugar 31 este año, la Católica del Norte al 16, la Católica
            de Temuco al 20 y la del Bío-Bío al 21. Fueron 12 los planteles que
            en total bajaron su nota en 2021.{' '}
          </p>

          <p>
            Al ingresar la U. Adventista este año al ranking —en las versiones
            pasadas no fue incluida debido a que su nivel de investigación era
            incipiente—, no registra valores para la edición 2020.{' '}
          </p>

          <p className="destacada text-bold">
            Este año, las primeras 11 universidades del ranking se mantienen sin
            movimiento; algo que no ha ocurrido en los 22 años que hemos
            realizado este estudio de opinión.{' '}
          </p>

          <p className="destacada text-bold">
            La U. de Atacama y la U. San Sebastián son las grandes ganadoras, la
            primera saltó cinco puestos y la segunda cuatro, ubicándose en el 29
            y el 27, respectivamente.{' '}
          </p>

          <p className="destacada text-bold">
            Las universidades estatales de O'Higgins y de Aysén no son
            incluidas, ya que fueron fundadas en 2015.
          </p>
        </Columns>
        <CalidadDelMercadoLaboral />
        <Summary />
      </Content>
    </Layout>
  )
}

export default IndexPage
